// Vendor libraries
import { ElementRef, Renderer2, RendererFactory2, SimpleChanges, } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// Services
import { SvgSpriteService } from 'NewAngular/services/svg-sprite.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/svg-sprite.service";
/**
 *
 * Icon Directive
 *
 * Displays an icon svg using an inlined sprite for better performance
 *
 * Input Properties:
 *
 *  name: The name of the icon (e.g. "icon-save")
 *
 */
export class IconDirective {
    constructor(el, rendererFactory, svgSpriteService) {
        this.el = el;
        this.rendererFactory = rendererFactory;
        this.svgSpriteService = svgSpriteService;
        this.iconSVG = undefined;
        this.XML_NAMESPACE = 'http://www.w3.org/2000/svg';
        this.destroy$ = new Subject();
        this.spriteReady = false;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    ngOnInit() {
        // Initialize the sprite service - the service handles idempotency internally
        this.svgSpriteService.inlineSprite();
        // Subscribe to sprite load status
        this.svgSpriteService
            .isSpriteLoaded()
            .pipe(takeUntil(this.destroy$))
            .subscribe((loaded) => {
            if (loaded && !this.spriteReady) {
                this.spriteReady = true;
                // Create the icon once sprite is ready
                this.createIcon();
            }
        });
    }
    ngOnChanges(changes) {
        if (changes?.name?.currentValue !== changes?.name?.previousValue) {
            if (this.iconSVG)
                this.destroyIcon();
            this.createIcon();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    createIcon() {
        // Don't create icon if sprite isn't ready yet
        if (!this.spriteReady) {
            return;
        }
        this.renderer.setAttribute(this.el.nativeElement, 'xmlns', this.XML_NAMESPACE);
        this.renderer.addClass(this.el.nativeElement, this.name);
        // Always use inline mode - create the reference to the inlined sprite
        const inlineUrl = this.svgSpriteService.getInlineReference(this.name);
        this.createSVGElement(inlineUrl);
    }
    /**
     * Create icon synchronously without waiting for sprite to load.
     * Use this when manually instantiating the directive and you know the sprite is already loaded.
     */
    createIconSync() {
        this.renderer.setAttribute(this.el.nativeElement, 'xmlns', this.XML_NAMESPACE);
        this.renderer.addClass(this.el.nativeElement, this.name);
        // Always use inline mode - create the reference to the inlined sprite
        const inlineUrl = this.svgSpriteService.getInlineReference(this.name);
        this.createSVGElement(inlineUrl);
    }
    createSVGElement(url) {
        /**
         * 1. Sets the <svg> element class and href attributes.
         * 2. Creates the <use> element as a child of the <svg> element.
         */
        this.iconSVG = this.renderer.createElement('use', this.XML_NAMESPACE);
        this.renderer.setAttribute(this.iconSVG, 'href', url);
        this.renderer.appendChild(this.el.nativeElement, this.iconSVG);
    }
    destroyIcon() {
        this.renderer.removeChild(this.el.nativeElement, this.iconSVG);
        this.iconSVG = undefined;
    }
}
IconDirective.ɵfac = function IconDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IconDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.RendererFactory2), i0.ɵɵdirectiveInject(i1.SvgSpriteService)); };
IconDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: IconDirective, selectors: [["svg", "ycnIcon", ""]], inputs: { name: "name" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature] });
